var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cell-container"},[_c('div',{staticClass:"cell-value",attrs:{"title":_vm.value},on:{"click":function($event){return _vm.btnClickedHandler()}}},[_vm._v(_vm._s(_vm.value))])])
}
var staticRenderFns = []

export { render, staticRenderFns }